<template>
  <div class="flex items-center">
    <Slider v-model="val" class="site-ui-slider w-full" v-bind="$attrs" @change="onChange" />
    <input
      v-model="inputValue"
      class="w-[35px] flex-shrink-0 h-[22px] text-center outline-none bg-fillColor-3 rounded-sm flex items-center justify-center"
      @keyup="inputValue=String(inputValue).replace(/^(0+)|[^\d]+/g,'')"
      @input="debounceInput"
    />
  </div>
</template>
<script>
import { Slider } from 'element-ui'
import debounce from 'lodash.debounce'
import {insertStep} from '~/utils/event'

export default {
  name: "MenuSlider",
  components: {
    Slider
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    targetKey: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      val: this.value,
      inputValue: this.value,
      debounceInput: ''
    }
  },
  watch: {
    value() {
      this.val = this.value
      this.inputValue = this.value
    }
  },
  mounted() {
    this.debounceInput = debounce(this.onInput, 500)
  },
  methods: {
    onChange(value) {
      this.inputValue = value
      insertStep(this, [this.targetKey], this.value)
      this.$emit('change', value)
    },
    onInput() {
      const max = 100
      let number = Number(this.inputValue)
      if (number > max) {
        number = max
      }
      this.val = number
      this.onChange(number)
    }
  }
}
</script>

<style lang="less" scoped>
.site-ui-slider {
  padding: 0 6px;
  /deep/ .el-slider__button-wrapper {
    top: -16px;
  }
  /deep/ .el-slider__runway {
    background-color: @handle-bg;
    height: 4px;
    margin: 4px 0;
  }

  /deep/ .el-slider__bar {
    background: @primary-color;
    height: 4px;
  }

  /deep/ .el-slider__button {
    width: 12px;
    height: 12px;
    background: white;
    border: none;
    box-shadow: -1px 0px 2px rgba(33, 49, 170, 0.3);
  }
}
</style>
